import { SessionJsonStorage } from 'utils/storage';

export const env = {
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  APP_ENV: process.env.REACT_APP_NODE_ENV,
  CONFIG_URL: process.env.REACT_APP_CONFIG_URL,
  IS_CATERING: Boolean(process.env.REACT_APP_IS_CATERING && JSON.parse(process.env.REACT_APP_IS_CATERING)),
  GTM_ID: process.env.REACT_APP_GTM_ID,
  ORG_ID: process.env.REACT_APP_ORG_ID,
  IS_MARKETPLACE: Boolean(process.env.REACT_APP_ORG_ID),
  LANG: process.env.REACT_APP_LANG,
  PRIMARY_COLOR: process.env.REACT_APP_PRIMARY_COLOR,
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyCJQt4EfdWfsGYtDUngHd6jP9YWO5ihy4w',
  CATERING_REWARD_DISABLED: process.env.REACT_APP_CATERING_REWARD_DISABLED,
  WL_ROOT_DOMAIN: process.env.REACT_APP_WL_ROOT_DOMAIN || 'caterlocally.com',
  RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
};
export const isDevelopment = process.env.NODE_ENV === 'development';

window.ENV = env;
export const apiUrl = `${getBaseURL().url}api/`;

export const DAYS = [
  {
    title: 'monday',
    id: 1,
  },
  {
    title: 'tuesday',
    id: 2,
  },
  {
    title: 'wednesday',
    id: 3,
  },
  {
    title: 'thursday',
    id: 4,
  },
  {
    title: 'friday',
    id: 5,
  },
  {
    title: 'saturday',
    id: 6,
  },
  {
    title: 'sunday',
    id: 7,
  },
  {
    title: 'weekdays',
    id: 8,
  },
  {
    title: 'weekends',
    id: 9,
  },
  {
    title: 'everyday',
    id: 10,
  },
];

export const GFO_TOKEN = 'rwg_token';


export const BOTTOM_NAV_HEIGHT = 72;
export const HEADER_HEIGHT = 64;

export function getBaseURL() {
  let url = env.APP_ENV === 'production' ? process.env.REACT_APP_BASE_URL :
    SessionJsonStorage.get('baseURL') || process.env.REACT_APP_BASE_URL;

  if (!url.startsWith('https://') && !url.startsWith('http://')) {
    url = `https://${url}`;
  }

  if (!url.endsWith('/')) {
    url = `${url}/`;
  }
  return {
    url,
    customized: process.env.REACT_APP_BASE_URL !== url,
  };
}

export const ListItemsTypes = {
  MERCHANT: 'MERCHANT',
  MARKETING_CARDS: 'MARKETING_CARDS',
};

export const EMPTY_OBJECT = Object.freeze({});
export const EMPTY_ARRAY = Object.freeze([]);
export const FCM_TOKEN_STORAGE_KEY = 'fcmToken';
